module.exports = {"en":{"tooltipText":"EVE Time (UTC)"},"de":{"tooltipText":"EVE-Zeit (UTC)"},"fr":{"tooltipText":"Heure d'EVE (UTC)"},"ru":{"tooltipText":"Время EVE Online (UTC)"},"zh":{"tooltipText":"时间（世界时）"}}


//////////////////
// WEBPACK FOOTER
// ./src/features/Clock/localization/localized.json
// module id = 1164
// module chunks = 0